/**
 * Available UI actions.
 *
 * @module actions
 */

'use strict';

module.exports = {
    resetFilters:      0,
    search:            1,
    createFolder:      2,
    deleteFile:        3,
    pinShare:          4,
    renamePinnedShare: 5,
    unpinShare:        6,
    setFavoritesState: 7,
    clearFavorites:    8,
    clearSmbCache:     9,
    clearNfsCache:     10
};
